import { createContext, useContext } from 'react'

interface PostListContextValue {
	type: 'FOLLOW' | 'EXPLORE' | 'TOPIC' | 'SEARCH' | 'PERSONAL_UPDATE' | 'COLLECTION'
}

export const PostListContext = createContext<PostListContextValue | null>(null)

export function usePostListContext() {
	return useContext(PostListContext)
}
